<template>
  <div class="definition-layout">
    <MobileHeader :label="$t('nav.definition')" />
    <div
      class="master-detail__master master-detail__master--space master-detail__master--small"
    >
      <ElementTypesNav
        :items="shaftElementTypes"
        v-if="!loading && shaftElementTypes"
      />
      <Loader v-if="loading" />
      <div class="form form--dark">
        <div class="form-row">
          <router-link
            v-if="currentShaft?.policy?.edit"
            :to="{ name: 'editShaft', params: { shaftId: currentShaft.id } }"
            :aria-label="$t('inspections.edit_shaft_info')"
          >
            <button class="button button--full-width">
              {{ $t("inspections.edit_shaft_info") }}
            </button>
          </router-link>
        </div>
      </div>
    </div>

    <!-- Main and right panel -->
    <div
      :class="{
        'definition-layout__view definition-layout__view--border-left': true,
        'show-for-medium': !elementType,
      }"
    >
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

import useAjax from '@/functions/use_ajax';
import { convertToUnderscore } from '@/functions/convert_to_underscore';

import MobileHeader from '@/components/generic/mobile_header.vue';
import ElementTypesNav from '@/components/shafts/definition/element_types_nav.vue';
import Loader from '@/components/generic/loader.vue';
import { useShaft } from '@/functions/use_remote_object';

const props = defineProps({
  elementType: { type: String, required: false, default: null },
  organisationId: { type: String, required: true },
  shaftId: { type: String, required: true },
});
const ajax = useAjax();
const router = useRouter();
const loading = ref(false);
const shaftElementTypes = ref(null);
const currentShaft = useShaft(props);

onMounted(() => {
  loadShaftElementTypes();
});

/**
 * Get shaft element types
 * (for left panel nav)
 */
const loadShaftElementTypes = async () => {
  loading.value = true;

  let { ok, data } = await ajax(
    `/organisations/${props.organisationId}/shafts/${props.shaftId}/grouped_elements`
  );

  if (ok) {
    const newGroupedElements = {};
    data.forEach((item) => {
      newGroupedElements[item.element_type] = item.count;
    });

    shaftElementTypes.value = newGroupedElements;

    if (!props.elementType) {
      router.replace({
        name: 'shaftGroup',
        params: {
          elementType: convertToUnderscore(Object.keys(shaftElementTypes.value)[0])
        },
      });
    }
  }

  loading.value = false;
};
</script>
